import { render, staticRenderFns } from "./EditAdmin.vue?vue&type=template&id=4999558e&scoped=true&"
import script from "./EditAdmin.vue?vue&type=script&lang=js&"
export * from "./EditAdmin.vue?vue&type=script&lang=js&"
import style0 from "./EditAdmin.vue?vue&type=style&index=0&id=4999558e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4999558e",
  null
  
)

export default component.exports